import Content from './containers/ContentWrapperContainer'

export default Content;